import React from 'react';
import { ClubSectionIcon } from '../clubs/dashboard/ClubSectionIcons';

export const isBlockBookingSession = (session) =>
  Boolean(session?.session_block_id || session?.is_block_session);

const BlockBookingBadge = ({ session, className = '' }) => {
  if (!isBlockBookingSession(session)) return null;

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md border border-info/30 bg-info-light px-2 py-0.5 text-xs font-medium text-info ${className}`}
      title="This session is part of a block booking"
    >
      <ClubSectionIcon type="planning" className="h-3.5 w-3.5" />
      Block booking
    </span>
  );
};

export default BlockBookingBadge;
